// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
import {
  phaseOrder,
} from "../core/config.js";

export function phaseSegments(data = []) {
  if (!data.length) return [];
  const segments = [];
  let start = 0;
  const pointPercent = (index) => index / Math.max(data.length - 1, 1) * 100;
  for (let index = 1; index <= data.length; index += 1) {
    if (index < data.length && data[index].phase === data[start].phase) continue;
    const name = data[start].phase || "Unknown";
    const first = data[start];
    const last = data[index - 1];
    const startSeconds = first?.elapsedSeconds ?? start;
    const endSeconds = last?.elapsedSeconds ?? index - 1;
    segments.push({
      name,
      start: pointPercent(start),
      end: index < data.length ? pointPercent(index) : 100,
      startIndex: start,
      endIndex: index - 1,
      startSeconds,
      endSeconds,
      durationSeconds: Math.max(0, endSeconds - startSeconds),
      count: index - start,
    });
    start = index;
  }
  return segments.filter((segment) => segment.name !== "Unknown");
}

export function availablePhasesForData(data = [], order = phaseOrder) {
  const found = new Set(data.map((point) => point.phase).filter(Boolean));
  return order.filter((phase) => found.has(phase));
}
